export default __webpack_public_path__ + "static/media/move_to_high.37f666bd.png";